import React from 'react';

const QuillEditor = ({ value, onChange }) => (
  <textarea
    value={value || ''}
    onChange={(e) => onChange(e.target.value)}
    spellCheck={false}
    placeholder="<p>Rédigez votre contenu HTML ici...</p>"
    className="w-full p-4 font-mono text-sm border-2 border-gray-200 dark:border-gray-700 rounded-xl bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-100 resize-none outline-none focus:border-blue-400 dark:focus:border-blue-500"
    style={{ minHeight: '500px' }}
  />
);

export default QuillEditor;
